var messages = {
  zoomInText: 'ズームイン',
  zoomOutText: 'ズームアウト',
  rotateRightText: '時計回りに90°回転',
  resetText: '画像サイズ',
  copyText: 'コピー',
  downloadText: 'ダウンロード',
  originalText: '100% に切り替える',
  tipsContent: 'ESC を押して全画面表示モードを終了する'
};
export default messages;